import { render, staticRenderFns } from "./PopupPlanRegAdmin.vue?vue&type=template&id=f4b1b9a6&scoped=true&"
import script from "./PopupPlanRegAdmin.vue?vue&type=script&lang=js&"
export * from "./PopupPlanRegAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PopupPlanRegAdmin.vue?vue&type=style&index=0&id=f4b1b9a6&prod&lang=css&"
import style1 from "./PopupPlanRegAdmin.vue?vue&type=style&index=1&id=f4b1b9a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b1b9a6",
  null
  
)

export default component.exports